import axios from "../config/axios"


export const VoiceModelRepository = {
  getAll: () => {
    return axios.get(`/api/voice-model/all`);
  },
  getPaged: (page = 0, size = 10) => {
    return axios.get(`/api/voice-model`, {params: {page, size}});
  },
  getMyModels: () => {
    return axios.get(`/api/voice-model/my`);
  },
  getPublicModels: () => {
    return axios.get(`/api/voice-model/public`);
  },
  getByOrganization: (organizationId) => {
    return axios.get(`/api/voice-model/organization/${organizationId}`);
  },
  getById: (id) => {
    return axios.get(`/api/voice-model/${id}`);
  },
  create: (model) => {
    return axios.post(`/api/voice-model`, model);
  },
  // apiKey and connectionString cannot be changed after creation, the backend ignores them here
  edit: (id, model) => {
    return axios.put(`/api/voice-model/${id}`, model);
  },
  delete: (id) => {
    return axios.delete(`/api/voice-model/${id}`);
  },
}
